import(/* webpackMode: "eager" */ "/codebuild/output/src1246806443/src/src/app/page.tsx");
